import { useState } from "react";
import { adminApi } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eraser } from "lucide-react";
import { toast } from "sonner";

export const ResetDemoDataButton = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await adminApi.post("/admin/reset-demo-data", { confirm });
      const total = Object.values(r.data.deleted).reduce((a, b) => a + b, 0);
      toast.success(`Dados zerados: ${total} registros removidos`);
      setOpen(false); setConfirm(""); onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao zerar"); }
    finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} className="border-rose-700 text-rose-400 hover:bg-rose-950 hover:text-rose-300 gap-2" data-testid="reset-demo-btn">
        <Eraser className="h-4 w-4" /> Zerar dados de demonstração
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="admin-dark bg-zinc-900 border-zinc-800 text-white" data-testid="reset-demo-dialog">
          <DialogHeader>
            <DialogTitle className="text-rose-400">Zerar todos os dados de demonstração?</DialogTitle>
            <DialogDescription className="text-zinc-400">
              Isso remove permanentemente todas as empresas, usuários, pedidos, produtos, clientes e pagamentos. Não há como desfazer. Digite <strong className="text-white">ZERAR</strong> para confirmar.
            </DialogDescription>
          </DialogHeader>
          <Input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="ZERAR" className="bg-zinc-950 border-zinc-800 text-white" data-testid="reset-demo-confirm-input" />
          <div className="flex justify-end gap-2 mt-2">
            <Button variant="ghost" onClick={() => setOpen(false)} data-testid="reset-demo-cancel">Cancelar</Button>
            <Button disabled={confirm !== "ZERAR" || busy} onClick={run} className="bg-rose-600 hover:bg-rose-700 text-white" data-testid="reset-demo-run">
              {busy ? "Zerando..." : "Zerar agora"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
